function fn_comp_configurator() {
    $comp = $(".comp_configurator");

    nl_fn_switch_content(".comp_configurator [data-switch-options]", 0);
    nl_fn_switch_content(".comp_configurator [data-switch-preview]", 0);

    $comp.find("[data-row-check] input[type=checkbox]").change(function () {
        $(this).parents("[data-row-check]").find(".col.hide").slideToggle(300).toggleClass("toggle");
    });

    // AUTOCOMPLETE FIX
    if ($comp.find("[data-row-check] [type=checkbox]").is(':checked')) {
        $comp.find("[data-row-check] [type=checkbox]:checked").parents("[data-row-check]").find(".col.hide").show();
    }

    $comp.find("[data-design-more]");

    $comp.find("[data-help]").on("click", function (e) {
        e.preventDefault();
        var $data = $(this).data("help");
        $(this).lightGallery({
            dynamic: true, counter: false, download: false, fullScreen: false, zoom: false, dynamicEl: [{
                "src": $data
            }]
        });
    });
    $("[data-stick-element]").stick_in_parent({recalc_every: 40});

    $comp.find("[data-switch-directory]").on("click", function (e) {
        e.preventDefault();
        var id = $(this).data("switch-directory");
        $(this).parents("[data-switch-options]").find(".switch-button."+id).trigger("click");
    });

    var design_more_copy = $("[data-design-more]").parents(".part_form").find("table").find("tbody tr").html();
    $comp.find("[data-design-more]").on("click", function(e){
        e.preventDefault();
        $(this).parents(".part_form").find("table tbody").append("<tr></tr>").find("tr:last-of-type").append(design_more_copy);
    });
}